import React from "react";
import { Typography } from "antd";

const Billing = () => {
  return (
    <div style={{ padding: 24 }}>
      <Typography.Title level={3}>Billing</Typography.Title>
      <Typography.Text type="secondary">
        Billing management coming soon.
      </Typography.Text>
    </div>
  );
};

export default Billing;
